import i18next from 'i18next';
import { trackPromise } from 'react-promise-tracker';
import api from '../api/api';
import { BackMappings } from '../utils/BackMappings';
import MisValesAhorroMockService from './mocks/MisValesAhorroMockService';
import { MocksHelper } from './mocks/MocksHelper';

// eslint-disable-next-line react-hooks/rules-of-hooks
const mocked = MocksHelper.useMocks();

const MisValesAhorroService = {
  retrieveValesAhorro: (data: object) =>
    trackPromise(
      api.post(
        `/rest/vales/ahorro/${i18next.language}/get/vales/usuario`,
        JSON.stringify(data),
      ),
    ),
  activarVale: (data: object) =>
    trackPromise(
      api.put(
        `/rest/vales/ahorro/${i18next.language}/activar/vale?view=${BackMappings.VALES}`,
        JSON.stringify(data),
      ),
    ),
  getValesPreferencia: () =>
    trackPromise(api.post('/rest/misdatos/get/datos/vales/ahorro/preferencia')),

  updateValesPreferencia: (data: object) =>
    trackPromise(
      api.put(
        '/rest/vales/ahorro/update/datos/vales/ahorro/preferencia',
        JSON.stringify(data),
      ),
    ),
};
export default mocked ? MisValesAhorroMockService : MisValesAhorroService;
